import React, { useState } from 'react';
import Navbar from './components/Navbar/Navbar';
import Header from './components/Header/Header';
import About from './components/About/About';
import Portfolio from './components/Portfolio/Portfolio';
import Parcours from './components/Parcours/Parcours';
import Experience from './components/Experience/Experience';
import Footer from './components/Footer/Footer';
import Contact from './components/Contact/contact';
import Carte from './components/Carte/Carte';
import { TranslationProvider, useTranslationContext } from './hooks/useAutoTranslate';
import DossierButton from './components/DossierCompetences/DossierCompetences';
import experiencesFr from './components/Experience/langue/fr.json';
import experiencesEn from './components/Experience/langue/en.json';
import parcourssFr from './components/Parcours/langue/fr.json';
import parcourssEn from './components/Parcours/langue/en.json';
import aboutFr from './components/About/langue/fr.json';
import aboutEn from './components/About/langue/en.json';
// ── JSON Header — contient "role" utilisé comme titre du dossier ──
import headerFr from './components/Header/langue/fr.json';
import headerEn from './components/Header/langue/en.json';
import './App.css';

// ── Données media du parcours (logos + certs) ─────────────────────
const parcoursMedia = [
  {
    img: 'assets/img/parcours/isen.png',
    certs: [
      { href: 'assets/certificat_toeic.pdf',          img: 'assets/img/techno/toeic.png', alt: 'TOEIC' },
      { href: 'assets/Label%20Handimanagement.pdf',   img: 'assets/img/techno/lh.png',   alt: 'Label Handimanagement' },
    ],
  },
  { img: 'assets/img/parcours/udemy.png' },
  { img: 'assets/img/parcours/anssi.png' },
  { img: 'assets/img/parcours/iut.png',    techs: ['python', 'plsql', 'java', 'linux', 'php', 'laravel', 'git', 'reseau'] },
  { img: 'assets/img/parcours/ulille.png' },
  { img: 'assets/img/parcours/med.png' },
  { img: 'assets/img/parcours/beaupre.png' },
];

// ── Chemins vers les CVs selon la langue ──────────────────────────
// Mets ici les chemins réels de tes fichiers PDF dans /public/assets/
const CV_URLS = {
  fr: '/assets/cv-baptiste_lemattre-fr.pdf',
  en: '/assets/cv-baptiste_lemattre-en.pdf',
};

function AppContent() {
  const [carteOuverte, setCarteOuverte] = useState(false);
  const { langue } = useTranslationContext();
  const isFr = langue === 'fr';

  const expData    = isFr ? experiencesFr : experiencesEn;
  const parcData   = isFr ? parcourssFr   : parcourssEn;
  const aboutData  = isFr ? aboutFr       : aboutEn;
  const headerData = isFr ? headerFr      : headerEn;   // ← JSON header

  const experiences   = Array.isArray(expData.experiences) ? expData.experiences : [];
  const parcoursItems = Array.isArray(parcData.items)      ? parcData.items      : [];

  const profile = {
    name:     `${headerData.prenom} ${headerData.nom}`,
    // "role" vient du JSON header → utilisé comme titre du dossier PDF
    role:     headerData.role || aboutData.label_etudiant || '',
    intro:    `${aboutData.para1 || ''} ${aboutData.para1_suite || ''}`.trim(),
    contacts: [
      { label: 'Lille, France' },
      { label: aboutData.label_permis || '' },
    ],
  };

  const labels = {
    parcours:    isFr ? 'Parcours'          : 'Education',
    experiences: isFr ? 'Expériences'       : 'Experiences',
    certifs:     isFr ? 'Certifications'    : 'Certifications',
    techs:       isFr ? 'Technologies'      : 'Technologies',
    missions:    isFr ? 'Missions & Tâches' : 'Missions & Tasks',
  };

  return (
    <div className="App">
      <Navbar onOpenCarte={() => setCarteOuverte(true)} />
      <Header onOpenCarte={() => setCarteOuverte(true)} />
      <About />
      <Portfolio />
      <Parcours />
      <Experience />
      <DossierButton
        profile={profile}
        parcoursItems={parcoursItems}
        parcoursMedia={parcoursMedia}
        experiences={experiences}
        lang={langue}
        labels={labels}
        cvUrl={CV_URLS}
      />
      <Contact />
      <Footer />
      {carteOuverte && (
        <Carte onClose={() => setCarteOuverte(false)} />
      )}
    </div>
  );
}

function App() {
  return (
    <TranslationProvider defaultLangue="fr">
      <AppContent />
    </TranslationProvider>
  );
}

export default App;